/**************************************************************************************************/
/*   File: /src/app/stores/effects/dossiers/effects.ts                                            */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu Apr 18 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap, withLatestFrom, filter } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import * as fromShared from '../../../shared';
import * as fromActions from '../../actions';
import * as fromStates from '../../states';
import { Store } from '@ngrx/store';

/**
 * The router effect
 */
@Injectable()
export class DossiersEffects {

  /**
   * The request to load all dossiers summaries
   * If has success dispath a LoadDossiersSummaries else DossierFail effect
   */
  @Effect()
  loadDossiersEffect$ = this.actions$.pipe(
    ofType<fromActions.fromDossiers.LoadDossiersSummaries>(
      fromActions.fromDossiers.DossiersActionTypes.LOAD_DOSSIERS_SUMMARIES
    ),
    switchMap((action: fromActions.fromDossiers.LoadDossiersSummaries) =>
      // Check if user is existing
      this.dossierService.getAllDossier().pipe(
        map(result =>
          // Check if user is pending
          new fromActions.fromDossiers.LoadDossiersSummariesSuccess(
            {
              dossiersSummaries: result
            }
          )
        ),
        catchError(error => {
          return of(
            new fromActions.fromDossiers.LoadDossiersSummariesFail(
              {
                message: new fromShared.models.Message(
                  fromShared.enums.MessageType.WARNING,
                  fromShared.enums.Messages.DOSSIERS_CANNOT_LOAD,
                  fromShared.enums.MessagePositionEnum.TOP,
                  fromStates.fromDossiers.STATE_NAME
                )
              }
            )
          );
        })
      )
    )
  );

  /**
   * Reload summaries on language changed
   */
  @Effect()
  reloadDossiersEffect$ = this.actions$.pipe(
    ofType<fromActions.fromUi.LanguageChangeSuccessAction>(
      fromActions.fromUi.UiActionTypes.LANGUAGE_CHANGE_SUCCESS_ACTION
    ),
    withLatestFrom(this.store, (action, state) => state.ui.user),
    filter(user => user !== undefined),
    map(action => new fromActions.fromDossiers.LoadDossiersSummaries())
  );


  /**
   * The contructor
   * @param store The store
   * @param actions$ The actions
   * @param router The router
   * @param location The location
   */
  constructor(
    private store: Store<fromStates.fromRoot.RootState>,
    private actions$: Actions,
    private dossierService: fromShared.services.DossierService
  ) { }
}
